import type { RouteLocation } from 'vue-router'
import type { SfEventExtended, SfAccountMini, SfAccount, SfUser, SfContactBasic } from '@lib/types/sfdc'
import type { CanvasRetrieve } from '@openapi'

export const CALL_STORAGE_KEY = 'call'
export interface EventDate {
  start: number | null
  end: number | null
}

export enum CallState {
  NO_CALL = 'NO_CALL',
  IN_CALL = 'IN_CALL',
  STOPPED = 'STOPPED',
}

export enum PostAction {
  CLOSE_WINDOW = 'close_window',
  REDIRECT = 'redirect',
}

export type CallPresentationHistory = {
  type: 'canvas' | 'section' | 'file' | 'page' | 'canvas_page'
  duration?: number
  timeStarted?: string
  lastTimeStarted?: string
  accumulatedDuration?: number
  name?: string
  page?: number
  component_ids?: string[]
  id: string
}[]

export type ContentRating = -1 | 0 | 1

export type CallPresentationHistoryMetadata = {
  [id: string]: {
    rating: ContentRating
  }
}

export interface Call {
  selectedEvent: SfEventExtended | null
  selectedAccount: SfAccountMini | null
  selectedContacts: SfContactBasic[]
  selectedUsers: SfUser[]
  accountPreselected: boolean
  selectedCanvas: CanvasRetrieve | null
  callState: CallState
  callStoppedAt: RouteLocation | null
  eventDate: EventDate
  postAction?: string | null
  postActionPath?: string | null
  presentationHistory?: CallPresentationHistory
  presentationHistoryMetadata?: CallPresentationHistoryMetadata
  recentAccounts?: SfAccount[]
}

export const INITIAL_CALL_STATE: Call = {
  selectedEvent: null,
  selectedAccount: null,
  selectedContacts: [],
  selectedUsers: [],
  accountPreselected: false,
  selectedCanvas: null,
  callState: CallState.NO_CALL,
  callStoppedAt: null,
  eventDate: {
    start: null,
    end: null,
  },
  postAction: null,
  postActionPath: null,
  presentationHistoryMetadata: {},
  presentationHistory: [],
  recentAccounts: [],
}
